module.exports = __webpack_public_path__ + "assets/46489b6efe082f22c7239687622b9121.png";